import { Box, Chip, Typography } from '@mui/material'
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded'
import CardWithSpace from '../../../components/Cards/CardWithSpace/index.jsx'
import UseTranslation from '../../../hooks/UseTranslation.jsx'
import TitleWithInfo from '../../../components/Cards/helpers/TitleWithInfo.jsx'

const AccessAndFeatures = ({ companyDetails, ssoAccessLabel, ssoAccessPositive }) => {
  const { t } = UseTranslation()
  const auditingEnabled = Boolean(companyDetails?.audit)
  const auditingDotColor = styles.statusDotColor(auditingEnabled)
  const auditingChipLabel = auditingEnabled ? t?.Enabled : t?.Disabled
  const auditingChipSx = styles.stateChip(auditingEnabled)
  const ssoDotColor = styles.statusDotColor(ssoAccessPositive)
  const ssoChipSx = styles.stateChip(ssoAccessPositive)

  return (
    <Box sx={styles.sectionGroup}>
      <CardWithSpace customStyles={styles.detailsCardShell}>
        <Box sx={styles.detailsHeader}>
          <Typography component="h2" sx={styles.detailsTitle}>
            {t?.['Access & features']}
          </Typography>
        </Box>
        <Box sx={styles.detailsBody}>
          <TitleWithInfo
            title={t?.Auditing}
            info={(
              <Chip
                size="small"
                icon={(
                  <FiberManualRecordRoundedIcon
                    sx={styles.statusDotIcon(auditingDotColor)}
                  />
                )}
                label={auditingChipLabel}
                sx={auditingChipSx}
              />
            )}
            customStyle={styles.detailRow}
          />
          <TitleWithInfo
            title={t?.SSO}
            info={(
              <Chip
                size="small"
                icon={(
                  <FiberManualRecordRoundedIcon
                    sx={styles.statusDotIcon(ssoDotColor)}
                  />
                )}
                label={ssoAccessLabel}
                sx={ssoChipSx}
              />
            )}
            customStyle={styles.detailRow}
          />
        </Box>
      </CardWithSpace>
    </Box>
  )
}

const styles = {
  statusDotColor: (isActive) => (isActive ? '#29CC8B' : '#92929d'),
  statusDotIcon: (color) => ({
    '&&': {
      color: `${color} !important`,
      fontSize: 14,
    },
  }),
  stateChip: (isActive) => (
    isActive
      ? {
        backgroundColor: 'rgba(41, 204, 139, 0.12)',
        color: '#1a8f5f',
        fontWeight: 600,
        border: 'none',
        '& .MuiChip-icon': { marginLeft: '8px' },
        '& .MuiChip-label': { px: 1 },
      }
      : {
        backgroundColor: 'rgba(146, 146, 157, 0.12)',
        color: '#696974',
        fontWeight: 600,
        border: 'none',
        '& .MuiChip-icon': { marginLeft: '8px' },
        '& .MuiChip-label': { px: 1 },
      }
  ),
  sectionGroup: {
    width: '100%',
    mb: { xs: 2.5, sm: 3 },
  },
  detailsCardShell: {
    border: '1px solid #e8eaed',
    borderRadius: '12px',
    boxShadow: 'none',
    marginBottom: 0,
    overflow: 'hidden',
    padding: 0,
  },
  detailsHeader: {
    px: { xs: 2.5, sm: 3 },
    pt: { xs: 2.5, sm: 3 },
    pb: { xs: 2, sm: 2.5 },
    borderBottom: '1px solid #ebecef',
  },
  detailsTitle: {
    fontWeight: 700,
    fontSize: { xs: '1rem', sm: '1.0625rem' },
    color: '#1b2559',
    lineHeight: 1.35,
    letterSpacing: '-0.01em',
  },
  detailsBody: {
    display: 'flex',
    flexDirection: 'column',
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 2,
    px: { xs: 2.5, sm: 3 },
    py: { xs: 2, sm: 2.25 },
    borderBottom: '1px solid #ebecef',
    marginRight: '0px !important',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(29, 158, 117, 0.05)',
    },
    ' & h5': {
      flexShrink: 0,
      width: { xs: '100px', sm: '300px' },
      minWidth: { xs: '100px', sm: '300px' },
      maxWidth: { xs: '100px', sm: '300px' },
      fontSize: { xs: '0.8125rem', sm: '0.875rem' },
      fontWeight: 400,
      color: '#92929d',
      lineHeight: 1.4,
    },
    ' & h6': {
      textAlign: { xs: 'right', sm: 'left' },
      width: { xs: '100px', sm: 'unset' },
      fontSize: '14px',
      flex: 1,
      wordBreak: 'break-word',
    },
  },
}

export default AccessAndFeatures
